import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useState } from 'react';
import { TooltipProvider } from '../Tooltip/TooltipProvider';
import { ToastProvider } from '../Toast/ToastProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const StartShellPanelStateContext = /*#__PURE__*/createContext(null);
const StartShellPanelDispatchContext = /*#__PURE__*/createContext(null);
const EndShellPanelStateContext = /*#__PURE__*/createContext(null);
const EndShellPanelDispatchContext = /*#__PURE__*/createContext(null);
const StartContentPanelStateContext = /*#__PURE__*/createContext(null);
const StartContentPanelDispatchContext = /*#__PURE__*/createContext(null);
const EndContentPanelStateContext = /*#__PURE__*/createContext(null);
const EndContentPanelDispatchContext = /*#__PURE__*/createContext(null);
/**
 * Provides app-wide context for Trellis layouts, including tooltip support and shared side panel state.
 * Wrap your application's root with this so components like PageLayout can coordinate behavior.
 */
export const AppProvider = t0 => {
  const $ = _c(14);
  const {
    children,
    defaultStartShellSidePanelOpen: t1,
    defaultEndShellSidePanelOpen: t2,
    defaultStartContentPanelOpen: t3,
    defaultEndContentPanelOpen: t4
  } = t0;
  const defaultStartShellSidePanelOpen = t1 === undefined ? false : t1;
  const defaultEndShellSidePanelOpen = t2 === undefined ? false : t2;
  const defaultStartContentPanelOpen = t3 === undefined ? false : t3;
  const defaultEndContentPanelOpen = t4 === undefined ? false : t4;
  const [startShellSidePanelOpen, setStartShellSidePanelOpen] = useState(defaultStartShellSidePanelOpen);
  const [endShellSidePanelOpen, setEndShellSidePanelOpen] = useState(defaultEndShellSidePanelOpen);
  const [startContentPanelOpen, setStartContentPanelOpen] = useState(defaultStartContentPanelOpen);
  const [endContentPanelOpen, setEndContentPanelOpen] = useState(defaultEndContentPanelOpen);
  let t5;
  if ($[0] !== children) {
    t5 = /*#__PURE__*/_jsx(EndContentPanelDispatchContext.Provider, {
      value: setEndContentPanelOpen,
      children: children
    });
    $[0] = children;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== endContentPanelOpen || $[3] !== t5) {
    t6 = /*#__PURE__*/_jsx(StartContentPanelDispatchContext.Provider, {
      value: setStartContentPanelOpen,
      children: /*#__PURE__*/_jsx(EndContentPanelStateContext.Provider, {
        value: endContentPanelOpen,
        children: t5
      })
    });
    $[2] = endContentPanelOpen;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== startContentPanelOpen || $[6] !== t6) {
    t7 = /*#__PURE__*/_jsx(EndShellPanelDispatchContext.Provider, {
      value: setEndShellSidePanelOpen,
      children: /*#__PURE__*/_jsx(StartContentPanelStateContext.Provider, {
        value: startContentPanelOpen,
        children: t6
      })
    });
    $[5] = startContentPanelOpen;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== endShellSidePanelOpen || $[9] !== t7) {
    t8 = /*#__PURE__*/_jsx(StartShellPanelDispatchContext.Provider, {
      value: setStartShellSidePanelOpen,
      children: /*#__PURE__*/_jsx(EndShellPanelStateContext.Provider, {
        value: endShellSidePanelOpen,
        children: t7
      })
    });
    $[8] = endShellSidePanelOpen;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== startShellSidePanelOpen || $[12] !== t8) {
    t9 = /*#__PURE__*/_jsx(TooltipProvider, {
      children: /*#__PURE__*/_jsx(ToastProvider, {
        children: /*#__PURE__*/_jsx(StartShellPanelStateContext.Provider, {
          value: startShellSidePanelOpen,
          children: t8
        })
      })
    });
    $[11] = startShellSidePanelOpen;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
AppProvider.displayName = 'AppProvider';

/**
 * Returns whether the start shell side panel is open.
 * @returns The start shell side panel open state.
 */
export const useStartShellPanelState = () => {
  const context = useContext(StartShellPanelStateContext);
  if (context === null) {
    throw new Error("useStartShellPanelState must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns the setter function for the start shell side panel open state.
 * @returns The start shell side panel open state setter.
 */
export const useStartShellPanelDispatch = () => {
  const context = useContext(StartShellPanelDispatchContext);
  if (context === null) {
    throw new Error("useStartShellPanelDispatch must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns whether the end shell side panel is open.
 * @returns The end shell side panel open state.
 */
export const useEndShellPanelState = () => {
  const context = useContext(EndShellPanelStateContext);
  if (context === null) {
    throw new Error("useEndShellPanelState must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns the setter function for the end shell side panel open state.
 * @returns The end shell side panel open state setter.
 */
export const useEndShellPanelDispatch = () => {
  const context = useContext(EndShellPanelDispatchContext);
  if (context === null) {
    throw new Error("useEndShellPanelDispatch must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns whether the start content side panel is open.
 * @returns The start content side panel open state.
 */
export const useStartContentPanelState = () => {
  const context = useContext(StartContentPanelStateContext);
  if (context === null) {
    throw new Error("useStartContentPanelState must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns the setter function for the start content side panel open state.
 * @returns The start content side panel open state setter.
 */
export const useStartContentPanelDispatch = () => {
  const context = useContext(StartContentPanelDispatchContext);
  if (context === null) {
    throw new Error("useStartContentPanelDispatch must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns whether the end content side panel is open.
 * @returns The end content side panel open state.
 */
export const useEndContentPanelState = () => {
  const context = useContext(EndContentPanelStateContext);
  if (context === null) {
    throw new Error("useEndContentPanelState must be used within a AppProvider");
  }
  return context;
};

/**
 * Returns the setter function for the end content side panel open state.
 * @returns The end content side panel open state setter.
 */
export const useEndContentPanelDispatch = () => {
  const context = useContext(EndContentPanelDispatchContext);
  if (context === null) {
    throw new Error("useEndContentPanelDispatch must be used within a AppProvider");
  }
  return context;
};